import produce from "immer";
import { LoadState } from "../../../constants/enums";
import { defaultApprovalHistoryState } from "./approval-history.state";
import {
  CLEAR_ACTIVITY_HISTORY_STATE,
  CLEAR_APPROVAL_HISTORY_STATE,
  FETCH_ACTIVITY_HISTORY_FAILED,
  FETCH_ACTIVITY_HISTORY_PROGRESS,
  FETCH_ACTIVITY_HISTORY_SUCCESS,
  FETCH_APPROVAL_HISTORY_FAILED,
  FETCH_APPROVAL_HISTORY_PROGRESS,
  FETCH_APPROVAL_HISTORY_SUCCESS,
} from "./approval-history.actions";
import { IApprovalHistoryActions } from ".";
import { IStoreState } from "../../store.types";

export const approvalHistoryReducer = (
  state: IStoreState["approvals"]["history"] = defaultApprovalHistoryState,
  action: IApprovalHistoryActions,
) => {
  switch (action.type) {
    case FETCH_APPROVAL_HISTORY_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.approval_hierarchy.loading = LoadState.InProgress;
        draftState.approval_hierarchy.data = [];
        draftState.approval_hierarchy.totalRecords = 0;
        draftState.approval_hierarchy.error = null;
      });
      return newState;
    }

    case FETCH_APPROVAL_HISTORY_SUCCESS: {
      const { data, totalRecords, message } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.approval_hierarchy.loading = LoadState.Loaded;
        draftState.approval_hierarchy.data = data;
        draftState.approval_hierarchy.message = message;
        draftState.approval_hierarchy.totalRecords = totalRecords;
        draftState.approval_hierarchy.error = null;
      });
      return newState;
    }

    case FETCH_APPROVAL_HISTORY_FAILED: {
      const { error } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.approval_hierarchy.loading = LoadState.Failed;
        draftState.approval_hierarchy.data = [];
        draftState.approval_hierarchy.totalRecords = 0;
        draftState.approval_hierarchy.error = error;
      });
      return newState;
    }

    case CLEAR_APPROVAL_HISTORY_STATE: {
      return defaultApprovalHistoryState;
    }

    // #############################################################################
    // Module Activity
    // #############################################################################

    case FETCH_ACTIVITY_HISTORY_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.module_activity.loading = LoadState.InProgress;
        draftState.module_activity.data = [];
        draftState.module_activity.totalRecords = 0;
        draftState.module_activity.error = null;
      });
      return newState;
    }

    case FETCH_ACTIVITY_HISTORY_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.module_activity.loading = LoadState.Loaded;
        draftState.module_activity.data = data;
        draftState.module_activity.totalRecords = totalRecords;
        draftState.module_activity.error = null;
      });
      return newState;
    }

    case FETCH_ACTIVITY_HISTORY_FAILED: {
      const { error } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.module_activity.loading = LoadState.Failed;
        draftState.module_activity.data = [];
        draftState.module_activity.totalRecords = 0;
        draftState.module_activity.error = error;
      });
      return newState;
    }

    case CLEAR_ACTIVITY_HISTORY_STATE: {
      return defaultApprovalHistoryState;
    }

    default: {
      return state;
    }
  }
};
